(function() {
    'use strict';
a3_cabin_reports.factory('CrewAssessmentCreatorFactory', CrewAssessmentCreatorFactory);
	
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name CrewAssessmentCreatorFactory
    * @description 
    *   Initializes new Crew Assessments
    * @ngInject
    */                                                         
function CrewAssessmentCreatorFactory(UserFactory, CrewAssessmentFactory, CrewAssessmentTemplateFactory, FlightFactory, CrewAssessmentMemberFactory) {

		var service = 
		{
			createNewCrewAssessment : createNewCrewAssessment,
			createCrewAssessments : createCrewAssessments
		}

        /**
         * Create New Crew Assessment from the api assessments
         * @memberof CrewAssessmentCreatorFactory
         * @returns {object} assessment 
         */
		function createNewCrewAssessment(assessment) {
			// load the user
			var user = UserFactory.getUser();
			if (user == null)
				return null;

			// load the crewAssessmentTemplate
			var crewAssessmentTemplates = CrewAssessmentTemplateFactory.getCrewAssessmentTemplateFromStorage();
			if (crewAssessmentTemplates == null)
				return null;

			// load the flight
			var flights = FlightFactory.getFlightsByRoute(assessment.Route, assessment.DutyDate);
			if (flights == null || flights.length==0)
				return null;


			// create the new crewAssessment
			var crewAssessment = CrewAssessmentFactory.getNewCrewAssessment();

			crewAssessment.Id = (assessment.Id == null) ? guid() : assessment.Id;
			crewAssessment.UserId = user.id;
			crewAssessment.Route = assessment.Route;
			crewAssessment.DutyDate = assessment.DutyDate;
			crewAssessment.DutyDay = assessment.DutyDay;

            crewAssessment.AcType = flights[0].AcType;
			crewAssessment = CrewAssessmentFactory.updateAssessmentFlights(crewAssessment,flights);

			crewAssessment.assessedBy = assessment.assessedBy;
			var IsExist = true

			for (var i = 0; i < assessment.assessmentCrew.length; i++) {
				var crewMember = CrewAssessmentMemberFactory.newMember();
				crewMember.aimsId = assessment.assessmentCrew[i].CrewAimsId;
				crewMember.id = assessment.assessmentCrew[i].CrewId;
				crewMember.assessmentItems = crewAssessmentTemplates;
				crewMember.name = assessment.assessmentCrew[i].Name;
				crewMember.IsCompleted = false;
				crewMember.IsValid = true;
				crewMember.IsExist = assessment.assessmentCrew[i].IsExist;
				crewMember.IsOutdated = assessment.assessmentCrew[i].IsOutdated;
				crewMember.EndPeriod = assessment.assessmentCrew[i].EndPeriod;

				if (!assessment.assessmentCrew[i].IsExist) {
					IsExist = false;
				}

				crewAssessment.CrewAssessmentMembers.push(crewMember);
			}


			crewAssessment.IsExist = IsExist;
			if(IsExist){
				crewAssessment.Status = "Stored";
			}
			// return the new crewAssessment
			return crewAssessment;
		}

        /**
         * Create New Crew Assessments from the api assessments
         * @memberof CrewAssessmentCreatorFactory
         * @returns {Array} crewAssessments 
         */
		function createCrewAssessments(assessments) {
			var crewAssessments = [];
			for (var i = 0; i < assessments.length; i++) {
				var crewAssessment = createNewCrewAssessment(assessments[i])
                if(crewAssessment){
                   crewAssessments.push(crewAssessment);
                }
				
			}
			return crewAssessments;
		}
    

		return service;
	}
        
})();